import React, { useCallback, useEffect, useState } from 'react';
import InspectionToolbar from './Toolbar/inspectionToolbar';
import VehicleInspectionRecordTable from './Table/VehicleInspectionRecordTable';
import Pagination from 'reusable/pagination';
import { PAGE_SIZE } from 'config/constant';
import axiosInstance from 'config/axiosInstance';

const VehicleInspectionManagement: React.FC = () => {
  const [searchValue, setSearchValue] = useState('');
  const [sortValue, setSortValue] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setCount] = useState(0);
  const [inspectionRecordData, setInspectionRecordData] = useState<any[]>([]);
  const [dateRange, setDateRange] = useState({ startDate: '', endDate: '' });
  const [failedInspection, setFailedInspection] = useState<boolean | null>(
    null
  );

  const handleSortChange = (sortValue: string) => {
    setSortValue(sortValue);
    setCurrentPage(1);
  };

  const handleSearchChange = (value: string) => {
    setSearchValue(value);
    setCurrentPage(1);
  };

  const handlePageChange = (value: number) => {
    setCurrentPage(value);
  };

  const handleDateRangeChange = (startDate: string, endDate: string) => {
    setDateRange({ startDate, endDate });
  };

  const handleFailedInspectionChange = (value: boolean | null) => {
    setFailedInspection(value);
  };

  const fetchData = useCallback(async () => {
    try {
      let apiUrl = `/v1/vehicle_inspection_records/?page=${currentPage}&pageSize=${PAGE_SIZE}&search=${searchValue}&sort=${sortValue}&startDate=${dateRange.startDate}&endDate=${dateRange.endDate}&inspecion_result=${failedInspection}`;
      if (failedInspection !== null) {
        apiUrl += `&failed=${failedInspection}`;
      }
      const response = await axiosInstance.get(apiUrl);
      setInspectionRecordData(response.data.results); 
      setCount(response.data.count);
    } catch (error) {
      console.error('Failed to fetch inspection records', error);
    }
  }, [searchValue, sortValue, currentPage, dateRange, failedInspection]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <section className="flex flex-col space-y-4">
      {/* Toolbar */}
      <div>
        <InspectionToolbar
          searchValue={searchValue}
          sortValue={sortValue}
          currentPage={currentPage}
          onSearchChange={handleSearchChange}
          onSortChange={handleSortChange}
          onPageChange={handlePageChange}
          onDateRangeChange={handleDateRangeChange}
          onFailedInspectionChange={handleFailedInspectionChange}
        />
      </div>
      {/* Table */}
      <div>
        <VehicleInspectionRecordTable inspectionRecord={inspectionRecordData} />
      </div>
      {/* Pagination */}
      <div>
        <Pagination
          allRows={count}
          rowsPerPage={PAGE_SIZE}
          currentPage={currentPage}
          onPageChange={handlePageChange}
        />
      </div>
    </section>
  );
};

export default VehicleInspectionManagement;
